import { Button, Menu, styled } from '@mui/material'

export const ButtonTextGreen = styled(Button)(({ theme }) => ({
  height: 40,
  color: theme.palette.success.dark,
  backgroundColor: theme.palette.success.light,
  '& span p': {
    fontWeight: 500
  },
  [theme.breakpoints.down('sm')]: {
    maxHeight: 44,
    height: 44,
    '& span p': {
      paddingLeft: 8,
      fontWeight: 500,
      fontSize: theme.typography.subtitle1.fontSize
    }
  }
}))

export const ShareItemContainer = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  color: theme.palette.grey[300],
  '& li': {
    display: 'flex',
    gap: 8,
    paddingTop: 12,
    paddingBottom: 12
  }
}))

export const ShareMenu = styled(Menu)(() => ({
  width: '100%',
  padding: 0,
  paper: {
    backgroundColor: 'rgb(51 54 56 / 87%)',
    backdropFilter: 'blur(4px)',
    '& ul': {
      padding: 0
    }
  }
}))
